import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie } from 'lucide-react';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  
  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);
  
  const acceptAll = () => {
    localStorage.setItem('cookie_consent', 'all');
    setShowBanner(false);
  };
  
  const acceptNecessary = () => {
    localStorage.setItem('cookie_consent', 'necessary');
    setShowBanner(false);
  };
  
  const rejectAll = () => {
    localStorage.setItem('cookie_consent', 'none');
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-terra-beige/20 shadow-2xl animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Cookie className="w-5 h-5 text-terra-beige" />
              <h3 className="font-sweet-sans text-lg font-normal text-earth-brown uppercase tracking-wide">
                Cookie Instellingen
              </h3>
            </div>
            <p className="font-sweet-sans text-sm text-almost-black/70 leading-relaxed">
              Wij gebruiken cookies om uw ervaring te verbeteren en om ons websiteverkeer te analyseren. 
              Door op "Accepteren" te klikken, stemt u in met het gebruik van alle cookies. 
              Lees meer in ons <a href="/privacy" className="text-terra-beige hover:text-earth-brown underline">privacybeleid</a>.
            </p>
          </div>
          
          <div className="flex flex-wrap gap-2">
            <Button
              onClick={rejectAll}
              variant="outline"
              size="sm"
              className="font-sweet-sans text-xs border-terra-beige/30 text-almost-black hover:bg-terra-beige/10"
            >
              Weigeren
            </Button>
            <Button
              onClick={acceptNecessary}
              variant="outline"
              size="sm"
              className="font-sweet-sans text-xs border-terra-beige text-earth-brown hover:bg-terra-beige hover:text-white"
            >
              Alleen Noodzakelijk
            </Button>
            <Button
              onClick={acceptAll}
              size="sm"
              className="font-sweet-sans text-xs bg-terra-beige hover:bg-terra-beige/90 text-white"
            >
              Alle Accepteren
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
